import type { ReactNode } from 'react';
import { InfoHint } from '@/components/InfoHint';
import { cn } from '@/lib/cn';

interface SectionTitleProps {
  title: string;
  id?: string;
  hint?: string;
  actions?: ReactNode;
  className?: string;
}

/** Section h2 above (or atop) a card, as in the original app. */
export function SectionTitle({ title, id, hint, actions, className }: SectionTitleProps): JSX.Element {
  return (
    <div className={cn('flex items-center gap-1.5', className ?? 'mb-3')}>
      <h2 id={id} className="text-base font-normal text-foreground">
        {title}
      </h2>
      {hint && <InfoHint text={hint} />}
      {actions && <div className="ml-auto flex items-center gap-2">{actions}</div>}
    </div>
  );
}
